import { render } from "./AddAuctionHouse.vue?vue&type=template&id=bc6dafa6&scoped=true"
import script from "./AddAuctionHouse.vue?vue&type=script&lang=js"
export * from "./AddAuctionHouse.vue?vue&type=script&lang=js"

import "./AddAuctionHouse.vue?vue&type=style&index=0&id=bc6dafa6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6dafa6"]])

export default __exports__